import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
var BAR_DIVIDER = "mx-3 my-2 w-px bg-gray-200";
export var BarDivider = function (_a) {
    var className = _a.className;
    return (_jsx("span", { className: clsx(BAR_DIVIDER, className) }, void 0));
};
